import { useEffect, useState } from 'react';

const navLinks = [
  { href: '#latest', label: '最新地址' },
  { href: '#guide', label: '打不开指南' },
  { href: '#category', label: '导航分类' },
  { href: '#community', label: '用户反馈' },
  { href: '#faq', label: '常见问题' },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return (
    <header
      className={`fixed inset-x-0 top-0 z-50 transition-all duration-300 ${
        scrolled
          ? 'bg-background-50/95 backdrop-blur border-b border-background-200/70'
          : 'bg-transparent'
      }`}
    >
      <div className="w-full px-4 md:px-10">
        <div className="flex items-center justify-between h-16 md:h-20">
          <a href="#top" className="flex items-center gap-3 group">
            <span className="w-10 h-10 flex items-center justify-center rounded-lg bg-primary-500 text-background-50 font-heading text-lg font-bold">
              51
            </span>
            <span className="flex flex-col leading-none">
              <span
                className={`font-heading text-lg md:text-xl font-bold tracking-tight ${
                  scrolled ? 'text-foreground-950' : 'text-background-50'
                }`}
              >
                51网址导航
              </span>
              <span
                className={`font-label text-[11px] tracking-[0.2em] mt-1 ${
                  scrolled ? 'text-foreground-500' : 'text-background-100/80'
                }`}
              >
                一键直达 · 防走失
              </span>
            </span>
          </a>

          <nav className="hidden md:flex items-center gap-8">
            {navLinks.map((link) => (
              <a
                key={link.href}
                href={link.href}
                className={`text-sm font-label transition-colors ${
                  scrolled
                    ? 'text-foreground-700 hover:text-primary-600'
                    : 'text-background-50/90 hover:text-background-50'
                }`}
              >
                {link.label}
              </a>
            ))}
          </nav>

          <div className="flex items-center gap-3">
            <a
              href="#latest"
              className="hidden md:inline-flex items-center gap-2 px-5 py-2.5 rounded-md text-sm font-label whitespace-nowrap bg-primary-500 text-background-50 hover:bg-primary-600 transition-colors cursor-pointer"
            >
              <i className="ri-flashlight-line"></i>
              进入最新地址
            </a>
            <button
              type="button"
              aria-label="打开菜单"
              onClick={() => setOpen((v) => !v)}
              className={`md:hidden w-10 h-10 flex items-center justify-center rounded-md border transition-colors ${
                scrolled
                  ? 'border-background-300 text-foreground-800'
                  : 'border-background-50/40 text-background-50'
              }`}
            >
              <i className={open ? 'ri-close-line' : 'ri-menu-3-line'}></i>
            </button>
          </div>
        </div>
      </div>

      {open && (
        <div className="md:hidden bg-background-50 border-t border-background-200/70">
          <nav className="px-4 py-4 flex flex-col">
            {navLinks.map((link) => (
              <a
                key={link.href}
                href={link.href}
                onClick={() => setOpen(false)}
                className="py-3 text-sm font-label text-foreground-700 border-b border-background-100 last:border-0"
              >
                {link.label}
              </a>
            ))}
          </nav>
        </div>
      )}
    </header>
  );
}